'use client';

import { DataTable } from '@/components/ui/data-table';
import { NewBlock, useBlockStore } from '@/stores/blockStore';
import { ColumnDef } from '@tanstack/react-table';
import { formatDistanceToNow, formatDistanceToNowStrict } from 'date-fns';

const columns: ColumnDef<NewBlock>[] = [
  {
    header: 'Height',
    accessorKey: 'height',
    cell: ({ row }) => {
      return <span className='text-[#D6F8D6]'>{row.original.height}</span>;
    },
  },
  {
    header: 'Time',
    accessorKey: 'time',
    cell: ({ row }) => {
      return formatDistanceToNowStrict(row.original.timestamp, { addSuffix: true });
    },
  },
  {
    header: 'Txs',
    accessorKey: 'transactions',
    cell: ({ row }) => {
      return row.original.txCount;
    },
  },
  {
    header: 'Proposer',
    accessorKey: 'proposer',
    cell: ({ row }) => {
      return row.original.validator.slice(0, 6) + '...' + row.original.validator.slice(-4);
    },
  },
  {
    header: 'Hash',
    accessorKey: 'hash',
    cell: ({ row }) => {
      return (
        <span className='text-[#D6F8D6]'>{row.original.hash.slice(0, 6) + '...' + row.original.hash.slice(-4)}</span>
      );
    },
  },
];

export default function NewBlockDataTable() {
  const realtimeOrders = useBlockStore(state => {
    return state.realtimeBlocks;
  });

  return (
    <div className='flex-1'>
      <DataTable
        data={realtimeOrders}
        columns={columns}
        tableTitle='Latest Blocks'
      />
    </div>
  );
}
